export const DOUBLE_MAX = 1.7976931348623157e308;

export const isAlphabetical = expression => {
  return /[a-zA-Z]+/.test(expression);
};

export const isValidDoubleValue = (x: number) => {
  return DOUBLE_MAX > x;
};



// WEBPACK FOOTER //
// ./src/utils/numbers.ts